import Skeleton from "@mui/material/Skeleton";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";

export default function MoodboardLoading() {
  return (
    <Grid item xs={12}>
      <Card>
        <CardContent sx={{ paddingBottom: 0 }}>
          <Skeleton
            animation="wave"
            variant="rectangular"
            height={18}
            width={"40%"}
            sx={{ borderRadius: 1 }}
          />
          <Box sx={{ paddingBottom: 1 }} />
          <Skeleton
            animation="wave"
            variant="rectangular"
            height={12}
            width={"20%"}
            sx={{ borderRadius: 1 }}
          />
        </CardContent>
        <CardContent>
          <Skeleton
            animation="wave"
            variant="rectangular"
            height={250}
            sx={{ borderRadius: 1 }}
          />
        </CardContent>
      </Card>
    </Grid>
  );
}
